
import { computed, defineComponent } from 'vue'
import { request, tasks } from '@/store/case'
import { formatDate } from '@/core/utils'
import { showModal } from '@/plugins/vue-final-modal'
import { isLoadingEndpoint } from 'mega-composable'

export default defineComponent({

  setup() {
    const upcomingTask = computed(() => tasks.value?.upcoming)
    const duration = computed(() => upcomingTask.value && `${formatDate(upcomingTask.value.startDate, 'p')} - ${formatDate(upcomingTask.value.endDate, 'p')}`)

    const isLoading = isLoadingEndpoint('request/tasks')

    return {
      upcomingTask,
      duration,
      request,
      showModal,
      isLoading
    }
  }
})

